









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteShopAddress, QueryShopAddressList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import EditShopAddressDialog from './EditShopAddressDialog.vue'
import { ShopAuditStatusFormat, ShopStatusFormat } from '@/utils/tyepconvert'
import {getUser} from '@/store/userStore'

@Component({
  components: {
    VQuery,
    VTable,
    EditShopAddressDialog,
  },
})
export default class VideoList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private  userInfo = getUser()

  // 查询条件
  private queryModels: Array<QueryModel> = [{ title: '店铺名称', param: 'shopName' }]
  // 全局操作
  private queryOperation: Array<TableOperation> = [{ title: '创建店铺地址', type: 'primary', click: this.openCreateVideo }]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺名称', param: 'shopName',hide:this.userInfo.user.role == 2},
    { title: '名字', param: 'name' },
    { title: '手机号', param: 'mobilePhone'},
    { title: '省', param: 'province' },
    { title: '市', param: 'city' },
    { title: '区', param: 'district' },
    { title: '详情地址', param: 'address' },
    { title: '默认收货地址', param: 'defaultRefundAddress', formatter: (data:boolean)=>{return data?"是":"否"} },
    {
      title: '操作',
      operation: [
        { title: '编辑', click: this.openEditVideo },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  public async created() {
    this.loadData()
  }

  private openCreateVideo() {
    const d = this.$refs.EditShopAddressDialog as EditShopAddressDialog
    d.open({}, false)
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteShopAddress({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }


  public openEditVideo(data: any) {
    const d = this.$refs.EditShopAddressDialog as EditShopAddressDialog
    d.open(data, true)
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryShopAddressList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
